export default __webpack_public_path__ + "e187ff5d8dc4ddd26c1d3545cffd2688.svg";